import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared';
import { UIRouterModule } from '@uirouter/angular';
import { InternalAdminRoute } from './internal-admin.route';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { JobEffects } from './store/jobs/jobs.effects';
import { eFAACTCustomerEffects } from './store/efaact-customer/efaact-customer.effects';
import * as jobreducer from './store/jobs/jobs.reducer';
import * as queuejobreducer from './store/queue-job/queue-job.reducer';
import * as efcustreducer from './store/efaact-customer/efaact-customer.reducer';
import { QueueJobEffects } from './store/queue-job/queue-job.effects';
import { TraceLoggingOverrideEffects } from './store/trace-logging-override/trace-logging-override.effects';
import * as traceLoggingOverrideReducer from './store/trace-logging-override/trace-logging-override.reducer';
@NgModule({
    providers: [],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [InternalAdminRoute]
        }),
        StoreModule.forFeature(jobreducer.JobFeatureKey, jobreducer.reducer),
        StoreModule.forFeature(efcustreducer.eFAACTCustomerFeatureKey, efcustreducer.reducer),
        StoreModule.forFeature(queuejobreducer.queueJobFeatureKey, queuejobreducer.reducer),
        StoreModule.forFeature(
            traceLoggingOverrideReducer.traceLoggingOverrideFeatureKey,
            traceLoggingOverrideReducer.reducer
        ),
        EffectsModule.forFeature([
            JobEffects,
            eFAACTCustomerEffects,
            QueueJobEffects,
            TraceLoggingOverrideEffects
        ])
    ]
})
export class InternalAdminModule {
    constructor() {}
}
